import { Controller } from "@hotwired/stimulus"

// Fills the Booking Settings form with the canonical defaults
// (CalendarConfig::BOOKING_SETTINGS_DEFAULTS, serialized by the view).
// Persisting still requires the explicit Save click — this only edits the
// form, and the dispatched change events let card-dirty enable Save.
export default class extends Controller {
  static values = { defaults: Object }

  revert() {
    const d = this.defaultsValue
    this.checkRadio("calendar_config[slot_duration_minutes]", d.slot_duration_minutes)
    this.setField("calendar_config[meeting_type]", d.meeting_type)
    this.setField("calendar_config[buffer_minutes]", d.buffer_minutes)
    this.setField("calendar_config[advance_notice_hours]", d.advance_notice_hours)
    this.setField("calendar_config[max_per_day]", d.max_per_day)
    this.setField("calendar_config[booking_window_days]", d.booking_window_days)
    this.setField("calendar_config[appointments_per_slot]", d.appointments_per_slot)
    // Booker manage links (#15840) — rendered only while the booking upgrades
    // are on; absent fields are skipped.
    this.setCheckbox("calendar_config[client_changes_enabled]", d.client_changes_enabled)
    this.setField("calendar_config[client_change_cutoff_hours]", d.client_change_cutoff_hours)
  }

  // The switch (shared/toggle_row) pairs the checkbox with a hidden "0" under
  // the same name, so target the checkbox itself.
  setCheckbox(name, checked) {
    const box = this.element.querySelector(`input[type="checkbox"][name="${name}"]`)
    if (!box || checked === undefined || box.checked === Boolean(checked)) return

    box.checked = Boolean(checked)
    box.dispatchEvent(new Event("change", { bubbles: true }))
  }

  checkRadio(name, value) {
    const radio = this.element.querySelector(`input[name="${name}"][value="${value}"]`)
    if (!radio || radio.checked) return

    radio.checked = true
    radio.dispatchEvent(new Event("change", { bubbles: true }))
  }

  setField(name, value) {
    const field = this.element.querySelector(`[name="${name}"]`)
    if (!field) return

    field.value = value === null || value === undefined ? "" : String(value)
    field.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
